import React from "react";
import "./variant-badge.scss";

export interface VariantBadgeProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, "children"> {
  text: string;
  backgroundColor: string;
  borderColor: string;
  textColor: string;
  className?: string;
}

const VariantBadge = ({
  text,
  backgroundColor,
  borderColor,
  textColor,
  className = "",
  style,
  ...rest
}: VariantBadgeProps) => {
  const wrapperStyle: React.CSSProperties = {
    borderColor,
    backgroundColor,
    ...style,
  };

  return (
    <div
      className={["variant-badge", className].filter(Boolean).join(" ")}
      style={wrapperStyle}
      role="status"
      aria-label={text}
      {...rest}
    >
      <span className="variant-badge__label" style={{ color: textColor }}>
        {text}
      </span>
    </div>
  );
};

export { VariantBadge };
export default VariantBadge;
